<template>
  <div>
    <v-dialog
      v-model="dialogVisible"
      persistent
      width="720">
      <v-card class="login-card">
        <v-row>
          <v-col cols="5">
            <v-img
              :aspect-ratio="2.533"
              width="150px"
              class="mt-5 ml-5"
              src="/images/logo.gif" />
            <div
              class="mt-5 ml-10 heading"
              style="font-size: 22px">
              <div>SRDM</div>
              <div>アスベスト</div>
              <div>リポートクリエーター</div>
            </div>
            <div class="mt-10 ml-10">
              <router-link
                :to="{ name: 'password-reset' }">
                パスワードを忘れた方はこちら
              </router-link>
            </div>
          </v-col>
          <v-col cols="7">
            <form
              class="pt-10"
              @submit.capture="submitForm">
              <v-card-text>
                <v-text-field
                  v-model="username"
                  :disabled="isLoading || succeeded"
                  placeholder="N0000"
                  label="メールアドレス または NADA会員番号"
                  outlined
                  required
                  @keypress.enter="$refs.password.focus()" />
                <v-text-field
                  ref="password"
                  v-model="password"
                  :disabled="isLoading || succeeded"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  placeholder="パスワード"
                  label="パスワード"
                  outlined
                  :error-messages="errorMessage"
                  @click:append="showPassword = !showPassword"
                  @keypress.enter="submitForm" />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  v-if="succeeded"
                  color="success">
                  認証成功
                </v-btn>
                <v-btn
                  v-else-if="!isLoading"
                  color="primary darken-1"
                  :disabled="isButtonDisabled"
                  @click="submitForm">
                  ログイン
                </v-btn>
                <v-btn
                  v-else
                  disabled>
                  <v-progress-circular
                    size="15"
                    indeterminate />
                  認証中
                </v-btn>
              </v-card-actions>
            </form>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'LoginDialog',

  data() {
    return {
      showPassword: false,
      dialogVisible: true,
      isLoading: false,
      succeeded: false,
      username: '',
      password: '',
      errorMessage: [],
    }
  },

  computed: {
    isFieldsEmpty() {
      return this.username === '' || this.password === ''
    },

    isFormDisabled() {
      return this.isLoading || this.succeeded
    },

    isButtonDisabled() {
      return this.isFieldsEmpty || this.isFormDisabled
    },
  },

  mounted() {
  },

  methods: {
    async submitForm() {
      const { username, password } = this
      const credentials = { username, password }

      this.errorMessage = ''
      this.isLoading = true

      try {
        await this.$store.dispatch(
          'auth/login',
          { credentials },
        )
        this.isLoading = false
        this.succeeded = true
        this.dialogVisible = false
        // トップ画面に遷移
        setTimeout(this.transitionToTopPage, 1000)
      } catch (err) {
        if (err.response.status === 401 || err.response.status === 400) {
          this.errorMessage = 'ログインに失敗しました。もう一度お試しください。'
          this.password = ''
        }
        this.isLoading = false
      }
    },

    transitionToTopPage() {
      this.dialogVisible = false
      window.location.href = '/'
    },
  },
}
</script>

<style scoped>
.login-card {
  background: url('/images/bg_foot.jpg');
  height: 340px;
}
</style>
